import {useSelector} from "react-redux";
import {RootState} from "../../store";
import React, {useEffect, useState, useRef} from 'react';
import "./Header.css";
import LoginNavigation from "./login/LoginNavigation";
import MobileMenu from "./MobileMenu/MobileMenu";
import LanguageMenu from "./LanguageMenu/LanguageMenu";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {makeLink} from "../common/languages-helper";
import {EXTERNAL_LINKS} from "../../config/external-links";




interface HeaderProps {
    isAuthenticated:boolean,
    loginFunction:any,
    logout:any
}

const Header: React.FC<HeaderProps> = ({isAuthenticated, loginFunction, logout}) => {
    const {t} = useTranslation();
    const profileData = useSelector((state: RootState) => state.profile);
    const isSessionWindow = () => {
        return document.location.href.includes('/csession-') || document.location.href.includes('/session-');
    }
    const firstRowMenu:any = [
        {
            'title': t('Main Page'),
            'url': EXTERNAL_LINKS.home
        },
        {
        'title': t('EMDRlink Device'),
            'url': EXTERNAL_LINKS.device
        },
        {
            'title': t('Find Therapist'),
            'url': EXTERNAL_LINKS.findTherapist
        },
        {
            'title': t('Training and Development'),
            'url': EXTERNAL_LINKS.training
        },
        {
            'title': t('Contact'),
            'url': EXTERNAL_LINKS.contact
        },
    ]
    const secondRowMenu:any = [
            {
                'title': t('Information about the program'),
                'url':EXTERNAL_LINKS.about
            },
            {
                'title': t('Pricing'),
                'url':makeLink('/cennik')
            },
            {
                'title': t('FAQ'),
                'url':makeLink('/faq')
            }
        ]
    return <div className={"header" + (isSessionWindow() ? " session-window" :"")}>
        <div className={"menu-top-row"}>
            {
                firstRowMenu.map((menuItem:any,index:number)=>{
                    const externalProps = typeof menuItem.url === "string" && menuItem.url.startsWith("http") ? {target:"_blank", rel:"noopener noreferrer"} : {};
                    return <div key={index} className={"menu-top-row-item"}><a href={menuItem.url} {...externalProps}>{menuItem.title}</a></div>
                })
            }
            {/*<LanguageMenu />*/}
        </div>
        <div className={"second-menu-row"}>
            <div className={"header-logo"}>
                <Link to={EXTERNAL_LINKS.home}>
                    <img src={"/logos/emdr-logo-new.svg"}></img>
                </Link>
            </div>
            <div key={2} className={"menu-second-row-item left-link-with-emphasis"}><a href={"/"}>Program EMDR Online</a></div>
           {/* {
                secondRowMenu.map((menuItem:any,index:number)=>{
                    return <div key={index} className={"menu-second-row-item"}><a href={menuItem.url}>{menuItem.title}</a></div>
                })
            }*/}

            <div className={"login-info"}>
                {
                    secondRowMenu.map((menuItem:any,index:number)=>{
                        const externalProps = typeof menuItem.url === "string" && menuItem.url.startsWith("http") ? {target:"_blank", rel:"noopener noreferrer"} : {};
                        return <div key={index} className={"menu-second-row-item"}><a href={menuItem.url} {...externalProps}>{menuItem.title}</a></div>
                    })
                }
                <div className={"desktop"}>
                    <LanguageMenu />
                </div>
            {
                !isSessionWindow() && <LoginNavigation isAuthenticated={isAuthenticated} loginFunction={loginFunction} logout={logout} />
            }
                <div className={"hamburger-menu"}>
                       {/*  &#9776; This is the hamburger icon */}
                      <MobileMenu
                          firstRowMenu={firstRowMenu}
                          secondRowMenu={secondRowMenu}
                          isAuthenticated={isAuthenticated}
                          loginFunction={loginFunction}
                          logout={logout}
                          showAuth={!isSessionWindow()}
                      />
                </div>

            </div>
        </div>
    </div>
}
export default Header;
